'use strict';

import React from 'react';
import Icon from '../atoms/Icon';
import Button from '../atoms/Button';

import './EditorHelp.less';

var Stamplet = React.createClass({
  propTypes: {
    onCloseClick: React.PropTypes.func.isRequired
  },

  render: function () {
    const notAllowedMessage = 'Sorry, this button doesn’t work on Stampsy.\\n\\nUse this button on the web page with images you want to collect.';
    const forbiddenMessage = 'Oups, it seems that Stampsy Bookmarklet cannot be used on this site, sorry.';

    const siteUrl = `https://${window.location.host}`;
    const loaderScript = `
      (function(d){
      var h=window.location.host;
      if(h.substr(-11)==='stampsy.com'||h.substr(0,9)==='localhost'){alert('${notAllowedMessage}');return;}
      var e=d.createElement('script');
      e.setAttribute('type','text/javascript');
      e.setAttribute('charset','UTF-8');
      e.setAttribute('src','${siteUrl}/static/stamplet/loader.js?r='+Math.random()*99999999);
      e.onerror=function(){alert('${forbiddenMessage}')};
      d.body.appendChild(e)})(document)
      `.replace(/(\n|\s{2,})/g, '');
    const stampletUrl = 'javascript' + ':' + encodeURIComponent(loaderScript);

    const stampletImageUrl = 'http://stampsy-eu-1.s3.amazonaws.com/uploads/05/07/2015/user/7/39377d0c-ca1a-428c-9325-d9830543edac.jpg';

    return (
      <div className='Modal-body Modal-body--wide EditorHelp'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Stampsy Bookmarklet
          </h3>
          <div onTouchTap={this.props.onCloseClick} className='Modal-close'>
            <Icon name='cross' size='small' mode='stroke' />
          </div>
        </div>
        <div className='Modal-content'>
          <div className='Modal-message'>
            Stampsy Bookmarklet makes it easy to save images you find on the web straight to your Stampsy Editor.
          </div>
          <div className='Modal-message'>
            <img className='utils--maxWidth' src={stampletImageUrl} />
          </div>
          <div className='Modal-message Modal-message--centered'>
            <b>↓ Drag this button to your bookmarks toolbar</b>
          </div>
          <Button color='green'
                  fill
                  fullWidth
                  size='large'
                  onClick={this.handleStampletClick}
                  href={stampletUrl}>
            Send to Stampsy
          </Button>
        </div>
      </div>
    );
  },

  handleStampletClick() {
    /* eslint-disable no-alert */
    alert('To install the Stampsy Bookmarklet, drag it to your bookmarks toolbar!');
    /* eslint-enable no-alert */
  }
});

export default Stamplet;


/** WEBPACK FOOTER **
 ** ./modals/Stamplet.jsx
 **/